import React from 'react';

const TextSlide = ({ AuthorImage, AuthorName, AuthorTitle, Heading, Address, Background }) => {
  return (
    <div className="swiper-slide">
      <div className={`hehts-slide-item white-bg-card ${Background}`}>
        <div className="hehts-to-card">
          <div className="hehts-card-img hehts-card-img-blank">
            <picture>
              <source srcSet="https://abconeprod.azureedge.net/dist/ABCD/assets/images/hehts-card-1.webp" type="image/webp" />
              <img
                className="hehts-card-img"
                src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/hehts-card-1.jpg"
                alt="Hear What The Experts Have To Say"
                width="100%"
                height="560"
                loading="lazy"
              />
            </picture>
          </div>
          <div className="hehts-to-card-overlay">
            <div className="overlay-top-content">
              <img
                src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/testimoial_quote.svg"
                className="testimonials_top_quote"
                width="100%"
                height="100%"
              />
              <div className="top-content-inner">
                <p className="card-top-para">{Heading}</p>
              </div>
              <img src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/testimoial_quote.svg" className="testimonials_bottom_quote" loading="lazy" />
            </div>
            <div className="card-overlay-inner">
              <div className="overlay-flex-card">
                <div className="card-profile-img">
                  <img
                    className="hehts-card-name-img"
                    src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/user-input.svg"
                    alt="Hear What The Experts Have To Say"
                    width="100%"
                    height="50"
                    loading="lazy"
                  />
                </div>
                <div className="card-profile-information">
                  <div className="profile-text">
                    <span className="card-name-heading">{AuthorName}</span>
                    <p className="card-discription">{AuthorTitle}</p>
                    <div className="card-date">
                      <p>
                        <img src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/map_marker.svg" loading="lazy" /> {Address}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextSlide;
